module.exports = __webpack_public_path__ + "files/1f07b8cf26e6c78b473be85b63ffe3d7.png";